import { Component } from '@angular/core';
import { ManagementComponent } from '@src/base-components/management/management.component'

@Component({
    selector: 'app-page-mananagement-messika',
    templateUrl: './management-messika.component.html'
})
export class ManagementMessikaComponent extends ManagementComponent {
}
